import {MakeSimpleCondition} from "../engine/Condition";
import {getCookie, setCookieDispatcher} from "../../../utils/CookieHelpers.js";

export interface CookieConditionOptions {
    key: string;
    equal?: any;
}

function verifyCookie(options: CookieConditionOptions) {
    const cookieValue = getCookie(options.key);
    return options.hasOwnProperty("equal") ? (cookieValue === options.equal) : cookieValue;
}

export const CookieCondition = MakeSimpleCondition<CookieConditionOptions>(verifyCookie, setCookieDispatcher);
